import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import StarRating from './stars/StarRating';

export default function ReviewItem({ comment, rating, createdAt, publicName, reply }) {
  return (
    <div className="reviews-slider__item  reviews-slider__item--masonry">
      <div className="reviews-slider__top">
        <div className="reviews-slider__author">
          {publicName || <FormattedMessage id="section.reviews.anonymous" />}
        </div>

        <div className="reviews-slider__rating">
          <StarRating value={rating} />
        </div>
      </div>

      <div className="reviews-slider__text">{comment}</div>

      {reply && (
        <div className="reviews-slider__reply">
          <div className="reviews-slider__reply-label">
            <FormattedMessage id="section.reviews.reply" />
          </div>
          <div className="reviews-slider__reply-text">{reply}</div>
        </div>
      )}

      {/* Temporarily hidden — restore to show the review date.
      <div className="reviews-slider__date">
        <FormattedDate year="numeric" month="long" day="numeric" value={createdAt} />
      </div>
      */}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/reviews/ReviewItem.js